import { render, staticRenderFns } from "./CopyrightPracticeIndex.vue?vue&type=template&id=1eb3674e&scoped=true&"
import script from "./CopyrightPracticeIndex.vue?vue&type=script&lang=js&"
export * from "./CopyrightPracticeIndex.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightPracticeIndex.vue?vue&type=style&index=0&id=1eb3674e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb3674e",
  null
  
)

export default component.exports